import React from 'react'

// Util
import _flatten from 'lodash/flatten'
import { observer } from 'mobx-react'

// My util
import PageContainer from 'components/Page/PageContainer'
import SettingsAppBar from 'views/Settings/SettingsAppBar'
import Settings from 'views/Settings/Settings'

const SettingsPage: React.FC = () => {
  return (
    <>
      <PageContainer>
        <SettingsAppBar />
        <Settings />
      </PageContainer>
    </>
  )
}

export default observer(SettingsPage)

